module.exports = __webpack_public_path__ + "static/img/2.9fd704f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/eng/2.png
// module id = FMT8
// module chunks = 0